import React from "react";
import { FileText, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const EjemploCapitulo = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
    {/* Header */}
    <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-6 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver
        </button>
        <div className="flex items-center gap-4 mb-4">
          <div className="bg-white/20 p-4 rounded-xl backdrop-blur-sm">
            <FileText className="w-12 h-12" />
          </div>
          <div>
            <h1 className="text-4xl md:text-5xl font-bold mb-2">
              Ejemplo de Capítulo
            </h1>
            <p className="text-xl text-green-100">
              Estructura y formato requerido para autores
            </p>
          </div>
        </div>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-6 py-12">
      <main className="flex-1 min-w-0">
        <div className="space-y-12">

          {/* Instrucciones generales */}
          <section id="instrucciones" className="scroll-mt-32">
            <div className="bg-gradient-to-br from-white via-orange-50/30 to-white rounded-2xl shadow-2xl p-8 border-l-8 border-[#0b742f] hover:shadow-3xl transition-shadow">
              <div className="prose prose-slate max-w-none text-base leading-relaxed text-gray-800">
                <h2 className="text-center font-bold text-2xl mb-8 text-[#0b742f] tracking-wide drop-shadow-sm border-b-2 border-orange-200 pb-4">
                  ESTRUCTURA PARA ELABORAR ARTÍCULO – CAPÍTULO EN EDITORIAL CENID
                </h2>

                <p className="mb-4 text-justify leading-7">
                  <strong>INSTRUCCIONES PARA AUTORES</strong> El CENID a través de sus medios de difusión y divulgación impresa y electrónica publica artículos de investigación que no han sido previamente publicados. Se busca lograr reportar de manera clara y precisa los resultados de una investigación, cuyo propósito es aportar información que contribuya al desarrollo educativo o del área de conocimiento en que se aplica. El contexto del trabajo (hallazgos de la literatura existente) y la elección de métodos deben ser claros en el texto. Se aceptan por igual enfoques cuantitativos, cualitativos o mixtos. Todos los manuscritos deben dejar claro cómo los hallazgos avanzan la comprensión del tema estudiado. Preparación de los manuscritos
                </p>

                <div className="mb-6 border-l-4 border-orange-400 pl-4 py-2 bg-orange-50/50 rounded">
                  <p className="font-bold text-gray-800">El límite en la extensión del artículo es de 20 cuartillas.</p>
                  <p className="font-bold text-gray-800">La extensión promedio de palabras es de 3,000 a 4,000.</p>
                </div>

                <hr className="my-6 border-gray-300" />

                <h3 className="text-center font-bold text-lg mb-1 text-gray-800">PAUTAS DE EDICIÓN</h3>
                <p className="text-center font-bold text-gray-700 mb-6">(LECTURA MUY RECOMENDADA ANTES DE INCIAR LA ELABORACIÓN DE SU TEXTO)</p>

                <div className="space-y-4">
                  <p><strong>Título del artículo</strong> (Solo mayúscula inicial – 25 palabras máximo)</p>
                  <p><strong>Title in English</strong> (Initial capital letter only – 25 words maximum)</p>
                </div>

                <div className="mt-8 flex justify-end bg-gradient-to-l from-orange-50 to-transparent p-4 rounded-lg">
                  <div className="text-right space-y-1">
                    <p className="font-bold text-gray-800">Datos de cada autor <span className="font-normal text-gray-600">(derecha)</span></p>
                    <p className="text-gray-700">a) Nombre completo de cada autor</p>
                    <p className="text-gray-700">b) Filiación institucional sin abreviaciones o acrónimos (no agregar área o departamento)</p>
                    <p className="text-gray-700">c) Información de correo electrónico</p>
                    <p className="text-gray-700">e) ID Orcid: https://orcid.org/0000-0000-0000-0000</p>
                  </div>
                </div>

                <div className="mt-6 space-y-4">
                  <p><strong>Disciplina:</strong> (Izquierda) (a qué disciplina pertenece)</p>

                  <div>
                    <p><strong>Resumen</strong> (Izquierda) (Máximo 200 palabras)</p>
                    <p className="text-justify leading-7">Debe ser escrito en tiempo pasado, tercera persona, y sin exceder 200 palabras. Debe reflejar completamente el contenido del manuscrito. Para informes de investigación y revisiones sistemáticas los resúmenes deberán ser estructurados en cinco apartados: Introducción, Objetivo, Método, Resultados (expresados de manera cuantitativa de ser posible) y Conclusiones.</p>
                  </div>

                  <div>
                    <p><strong>Palabras clave</strong> (Izquierda) (Máximo 6 palabras clave)</p>
                    <p className="text-justify">Las palabras clave a usar de ninguna manera deberán estar incluidas en el titulo</p>
                  </div>

                  <div>
                    <p><strong>Abstract</strong> (Left) (Less than 200 words)</p>
                  </div>

                  <div>
                    <p><strong>Key words</strong> (Left) (6 keywords)</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Introducción */}
          <section id="introduccion" className="scroll-mt-32">
            <div className="bg-gradient-to-br from-white via-green-50/30 to-white rounded-2xl shadow-2xl p-8 border-l-8 border-[#0b742f] hover:shadow-3xl transition-shadow">
              <div className="prose prose-slate max-w-none text-base leading-relaxed text-gray-800">
                <h2 className="text-center font-bold text-2xl mb-8 text-[#0b742f] tracking-wide drop-shadow-sm border-b-2 border-green-200 pb-4">
                  Introducción <span className="font-normal text-gray-500 text-lg">(Centrado)</span>
                </h2>
                <p className="mb-4 text-justify leading-7">
                  Debe expresar en forma precisa el problema, el objetivo general, indicar el fundamento del estudio o proyecto realizado y la metodología empleada para su presentación. Sustentar el aporte o contribución en base a una revisión breve del estado del arte, citando ordenadamente las referencias bibliográficas relacionadas con el tema. Para cerrar con el apartado, explicar en forma concisa la organización o estructura del artículo.
                </p>
                <p className="mb-6 text-justify leading-7">
                  El párrafo de arranque y párrafos subsecuentes no deben llevar sangría.
                </p>

                <div className="mt-6 space-y-4">
                  <p className="text-gray-700">Texto capítulo</p>
                  <div>
                    <p className="font-bold text-gray-800">Sub Capítulo</p>
                    <p className="text-justify leading-7">El párrafo de arranque y párrafos subsecuentes no deben llevar sangría.</p>
                  </div>
                </div>

                <div className="mt-6 p-5 bg-gradient-to-r from-blue-50 to-sky-50 border-l-4 border-blue-500 rounded-lg shadow-md ml-8">
                  <p className="mb-3 text-gray-800 text-justify leading-7">
                    Las citas de 40 palabras o más se escriben aparte del texto, con sangría, sin comillas, sin cursiva, con mismo tipo y tamaño de fuente. Al final de la cita se coloca el punto antes de los datos – recuerde que en las citas con menos de 40 palabras el punto se pone después. Al final de una cita en bloque, cite la fuente y el número de página o párrafo entre paréntesis después del signo de puntuación final. Deben tener una sangría izquierda de 1 cm, no deben llevar comillas y deben acabar con la fuente de la cita entre paréntesis. <span className="italic">(Apellido del autor, año de publicación, p. xx)</span>
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Metodología */}
          <section id="metodologia" className="scroll-mt-32">
            <div className="bg-gradient-to-br from-white via-purple-50/30 to-white rounded-2xl shadow-2xl p-8 border-l-8 border-[#0b742f] hover:shadow-3xl transition-shadow">
              <div className="prose prose-slate max-w-none text-base leading-relaxed text-gray-800">
                <h2 className="text-center font-bold text-2xl mb-8 text-[#0b742f] tracking-wide drop-shadow-sm border-b-2 border-purple-200 pb-4">
                  Metodología <span className="font-normal text-gray-500 text-lg">(Centrado)</span>
                </h2>

                <div className="mb-6">
                  <p className="font-bold text-gray-800 mb-2">Declaración de IA Generativa (ejemplo; especificar una de las dos opciones)</p>
                  <p className="text-justify leading-7 mb-3">
                    Se reconoce el uso de inteligencia artificial generativa (especificar nombre del modelo, ej. Gemini 1.5 Pro) durante el proceso de [redacción / análisis de datos / traducción]. El uso de esta herramienta se limitó a [especificar función, ej. la mejora de la cohesión gramatical], manteniendo los autores la responsabilidad total sobre la interpretación de los resultados y las conclusiones presentadas. Los detalles técnicos se describen en la sección de metodología <strong>(Si se empleó IA Generativa).</strong>
                  </p>
                  <p className="text-justify leading-7">
                    Declaración de IA Generativa: Los autores declaran que no se utilizaron herramientas de inteligencia artificial generativa ni tecnologías asistidas por IA para la redacción del manuscrito, el análisis de los datos o la creación de contenido original. Todo el trabajo fue realizado íntegramente por los autores de manera convencional <strong>(Si no se utilizó IA Generativa).</strong>
                  </p>
                </div>

                <div className="mb-6">
                  <p className="font-bold text-gray-800 mb-2">Responsabilidad (ejemplo; especificar esta sección)</p>
                  <p className="text-justify leading-7">
                    Como autor de este manuscrito, asumo la responsabilidad total por la veracidad y exactitud de los datos presentados, garantizando que toda la información ha sido verificada mediante fuentes primarias para evitar la generación de "alucinaciones" o datos ficticios derivados de procesos automatizados. Asimismo, declaro que el análisis se ha realizado bajo criterios de objetividad y neutralidad, implementando protocolos de revisión cruzada para identificar y mitigar posibles sesgos cognitivos o algorítmicos, asegurando así que las conclusiones reflejen fielmente la realidad técnica observada sin distorsiones.
                  </p>
                </div>

                <p className="mb-4 leading-7">El párrafo de arranque y párrafos subsecuentes no deben llevar sangría.</p>

                <div className="space-y-4">
                  <p className="text-gray-700">Texto capítulo</p>
                  <div>
                    <p className="font-bold text-gray-800">Sub Capítulo</p>
                    <p className="text-justify leading-7">El párrafo de arranque y párrafos subsecuentes no deben llevar sangría.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Resultados */}
          <section id="resultados" className="scroll-mt-32">
            <div className="bg-gradient-to-br from-white via-amber-50/30 to-white rounded-2xl shadow-2xl p-8 border-l-8 border-[#0b742f] hover:shadow-3xl transition-shadow">
              <div className="prose prose-slate max-w-none text-base leading-relaxed text-gray-800">
                <h2 className="text-center font-bold text-2xl mb-8 text-[#0b742f] tracking-wide drop-shadow-sm border-b-2 border-amber-200 pb-4">
                  Resultados <span className="font-normal text-gray-500 text-lg">(Centrado)</span>
                </h2>

                <p className="mb-4 leading-7">El párrafo de arranque y párrafos subsecuentes no deben llevar sangría.</p>

                <div className="space-y-4 mb-4">
                  <p className="text-gray-700">Texto capítulo</p>
                  <div>
                    <p className="font-bold text-gray-800">Sub Capítulo</p>
                    <p className="text-justify leading-7">El párrafo de arranque y párrafos subsecuentes no deben llevar sangría.</p>
                  </div>
                </div>

                <p className="text-justify leading-7 mb-6">
                  Cuando se incluyan tablas y figuras en el cuerpo del artículo, posiciónelas después del párrafo en el que son descritas. Cuando cite la fuente de información, debe incluirla en la parte de abajo de la figura en una "línea de fuente". Las tablas y figuras deben estar numeradas y llevar un título breve y descriptivo.
                </p>

                {/* Tabla ejemplo */}
                <div className="overflow-x-auto my-8">
                  <p className="text-center font-bold text-sm mb-3">
                    Tabla 1. <em>Ejemplo tabla (Times New Roman 10 pts., cursiva, centrado).</em>
                  </p>
                  <table className="min-w-full border-collapse border border-gray-400 text-sm bg-white">
                    <thead>
                      <tr className="bg-blue-50">
                        <th className="border border-gray-400 px-4 py-2 font-bold text-gray-800">Variable</th>
                        <th className="border border-gray-400 px-4 py-2 font-bold text-gray-800">M (DE)</th>
                        <th className="border border-gray-400 px-4 py-2 font-bold text-gray-800">IC 95%</th>
                        <th className="border border-gray-400 px-4 py-2 font-bold text-gray-800">p</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                        <td className="border border-gray-400 px-4 py-2 italic text-center">Dato</td>
                      </tr>
                    </tbody>
                  </table>
                  <p className="text-center text-sm italic mt-3 text-gray-600">
                    Fuente. Elaboración propia (2026) (incluir siempre la fuente).
                  </p>
                </div>

                {/* Figura ejemplo */}
                <div className="my-8">
                  <p className="text-center font-bold text-sm mb-3">
                    Figura 1. <em>Ejemplo de figura.</em>
                  </p>
                  <div className="border-2 border-gray-400 p-8 flex flex-col items-center justify-center min-h-32 bg-white">
                    <p className="italic text-gray-600 text-center">[ Insertar aquí la imagen en alta resolución (≥ 300 dpi) ]</p>
                    <p className="italic text-gray-600 text-center">Ancho recomendado: entre 8 y 15 cm</p>
                  </div>
                  <p className="text-center text-sm italic mt-3 text-gray-600">
                    Fuente. Elaboración propia (2026) (incluir siempre la fuente).
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Discusión */}
          <section id="discusion" className="scroll-mt-32">
            <div className="bg-gradient-to-br from-white via-rose-50/30 to-white rounded-2xl shadow-2xl p-8 border-l-8 border-[#0b742f] hover:shadow-3xl transition-shadow">
              <div className="prose prose-slate max-w-none text-base leading-relaxed text-gray-800">
                <h2 className="text-center font-bold text-2xl mb-8 text-[#0b742f] tracking-wide drop-shadow-sm border-b-2 border-rose-200 pb-4">
                  Discusión <span className="font-normal text-gray-500 text-lg">(Centrado)</span>
                </h2>
                <p className="mb-6 text-justify leading-7">
                  Es aquella en la que se relacionan los resultados de la investigación con la teoría, el estado de la cuestión y la propia investigación. A diferencia de la parte de resultados, que es muy expositiva, esta sección es predominantemente argumentativa, ya que requiere una toma de posición ante los datos y un ejercicio de pensamiento crítico para valorar justificadamente los aportes.
                </p>
                <p className="leading-7">El párrafo de arranque y párrafos subsecuentes no deben llevar sangría.</p>
              </div>
            </div>
          </section>

          {/* Conclusiones */}
          <section id="conclusiones" className="scroll-mt-32">
            <div className="bg-gradient-to-br from-white via-teal-50/30 to-white rounded-2xl shadow-2xl p-8 border-l-8 border-[#0b742f] hover:shadow-3xl transition-shadow">
              <div className="prose prose-slate max-w-none text-base leading-relaxed text-gray-800">
                <h2 className="text-center font-bold text-2xl mb-8 text-[#0b742f] tracking-wide drop-shadow-sm border-b-2 border-teal-200 pb-4">
                  Conclusiones <span className="font-normal text-gray-500 text-lg">(Centrado)</span>
                </h2>
                <p className="mb-4 text-justify leading-7">
                  Evite reproducir los aspectos contenidos en el resumen como conclusión. <em>Las conclusiones expuestas deben ser pertinentes exclusivamente al aporte realizado.</em> Si prefiere puede usar numeraciones. Una conclusión podría extender la importancia del trabajo o podría hacer pensar en aplicaciones y extensiones.
                </p>
                <p className="leading-7">El párrafo de arranque y párrafos subsecuentes no deben llevar sangría.</p>
              </div>
            </div>
          </section>

          {/* Futuras líneas de investigación */}
          <section id="futuras-investigacion" className="scroll-mt-32">
            <div className="bg-gradient-to-br from-white via-indigo-50/30 to-white rounded-2xl shadow-2xl p-8 border-l-8 border-[#0b742f] hover:shadow-3xl transition-shadow">
              <div className="prose prose-slate max-w-none text-base leading-relaxed text-gray-800">
                <h2 className="text-center font-bold text-2xl mb-8 text-[#0b742f] tracking-wide drop-shadow-sm border-b-2 border-indigo-200 pb-4">
                  Futuras líneas de investigación <span className="font-normal text-gray-500 text-lg">(Centrado)</span>
                </h2>
                <p className="mb-4 leading-7">Deberán ser escritas a renglón seguido, no numeradas.</p>
                <p className="mb-4 text-justify leading-7">
                  Mencionar de forma resumida aquellos aspectos que resultaron ser potencialmente interesantes para desarrollar en trabajos complementarios que deberán ser analizados en un futuro, ya que su alcance escapa a los primeramente planificados.
                </p>
                <p className="leading-7">El párrafo de arranque y párrafos subsecuentes no deben llevar sangría.</p>
              </div>
            </div>
          </section>

          {/* Disponibilidad de datos */}
          <section id="disponibilidad-datos" className="scroll-mt-32">
            <div className="bg-gradient-to-br from-white via-cyan-50/30 to-white rounded-2xl shadow-2xl p-8 border-l-8 border-[#0b742f] hover:shadow-3xl transition-shadow">
              <div className="prose prose-slate max-w-none text-base leading-relaxed text-gray-800">
                <h2 className="text-center font-bold text-2xl mb-8 text-[#0b742f] tracking-wide drop-shadow-sm border-b-2 border-cyan-200 pb-4">
                  Disponibilidad de datos <span className="font-normal text-gray-500 text-lg">(Centrado)</span>
                </h2>

                <div className="mb-6">
                  <p className="font-bold text-gray-800 mb-2">Datos del estudio (ejemplo; especificar una de las dos opciones)</p>
                  <p className="text-justify leading-7 mb-3">
                    Los datos que respaldan los hallazgos de este estudio están disponibles en Zenodo bajo el identificador https://doi.org/10.5281/zenodo.1234567 <strong>(Los datos ESTÁN disponibles).</strong>
                  </p>
                  <p className="text-justify leading-7">
                    Los datos no están disponibles públicamente debido a restricciones de confidencialidad médica y la protección de la identidad de los participantes, según lo estipulado en los protocolos de ética del comité institucional <strong>(Los datos NO están disponibles).</strong>
                  </p>
                </div>

                <div className="mb-6">
                  <p className="font-bold text-gray-800 mb-2">Protocolo / Código / Cuestionario: (ejemplo; especificar una de las dos opciones)</p>
                  <p className="text-justify leading-7 mb-3">
                    El protocolo de investigación y el código de procesamiento de datos en R están disponibles en el repositorio Zenodo bajo el DOI: 10.5281/zenodo.1234567. El cuestionario validado puede consultarse en el Anexo A del repositorio institucional <strong>(ESTÁN disponibles).</strong>
                  </p>
                  <p className="text-justify leading-7">
                    Protocolo / Código / Cuestionario: No disponible públicamente. El protocolo de intervención contiene información sensible de los participantes y el código es propiedad intelectual de la institución. Sin embargo, los materiales pueden ser proporcionados por el autor de correspondencia tras una solicitud razonable y previa evaluación del comité de ética <strong>(ESTÁN disponibles).</strong>
                  </p>
                </div>

                <div className="mb-6">
                  <p className="font-bold text-gray-800 mb-2">Fuente de financiamiento (ejemplo; especificar una de las dos opciones)</p>
                  <p className="text-justify leading-7 mb-3">
                    Este trabajo fue financiado por el Tecnológico Nacional de México (TecNM), bajo el proyecto de investigación con clave: 5678-2026-ITMA <strong>(Cuando SI fue financiado).</strong>
                  </p>
                  <p className="text-justify leading-7">
                    Los autores declaran que la presente investigación no recibió ninguna subvención específica de agencias de financiamiento del sector público, comercial o sin fines de lucro <strong>(Cuando NO fue financiado).</strong>
                  </p>
                </div>

                <div className="mb-6">
                  <p className="font-bold text-gray-800 mb-2">Conflicto de interés (ejemplo; especificar una de las dos opciones)</p>
                  <p className="text-justify leading-7 mb-3">
                    Los autores declaran que la investigación se realizó en ausencia de cualquier relación comercial o financiera que pudiera interpretarse como un posible conflicto de intereses <strong>(SIN conflicto de Interés).</strong>
                  </p>
                  <p className="text-justify leading-7">
                    Los autores informan los siguientes intereses: El Dr. [Nombre del Autor] ha recibido honorarios por consultoría de la empresa [Nombre de la Empresa], la cual proporcionó parte del equipo técnico utilizado en este estudio. Los demás autores declaran no tener conflictos de interés <strong>(CON conflicto de Interés).</strong>
                  </p>
                </div>

                <div className="mb-6">
                  <p className="font-bold text-gray-800 mb-2">Aprobación ética (ejemplo; especificar una de las dos opciones)</p>
                  <p className="text-justify leading-7 mb-3">
                    No aplica (sin participantes humanos/animales) <strong>(Cuando NO aplica).</strong>
                  </p>
                  <p className="text-justify leading-7">
                    Protocolo aprobado por el Comité de Ética en Investigación de la Facultad de Medicina de la Universidad Nacional, N° de protocolo: CEI-2024-0815 <strong>(Cuando aplica con protocolo aprobado).</strong>
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Agradecimientos */}
          <section id="agradecimientos" className="scroll-mt-32">
            <div className="bg-gradient-to-br from-white via-slate-50/30 to-white rounded-2xl shadow-2xl p-8 border-l-8 border-[#0b742f] hover:shadow-3xl transition-shadow">
              <div className="prose prose-slate max-w-none text-base leading-relaxed text-gray-800">
                <h2 className="text-center font-bold text-2xl mb-8 text-[#0b742f] tracking-wide drop-shadow-sm border-b-2 border-slate-200 pb-4">
                  Agradecimientos <span className="font-normal text-gray-500 text-lg">(Centrado)</span>
                </h2>
                <p className="text-center mb-4 italic text-gray-700">
                  [apartado opcional y al final del artículo, antes de la lista final de referencias]
                </p>
                <p className="text-center text-justify leading-7">
                  Aquí se insertará el párrafo del proyecto al que pertenece la investigación o agradecimientos.
                </p>
              </div>
            </div>
          </section>

          {/* Referencias */}
          <section id="referencias" className="scroll-mt-32">
            <div className="bg-gradient-to-br from-white via-emerald-50/30 to-white rounded-2xl shadow-2xl p-8 border-l-8 border-[#0b742f] hover:shadow-3xl transition-shadow">
              <div className="prose prose-slate max-w-none text-base leading-relaxed text-gray-800">
                <h2 className="text-center font-bold text-2xl mb-8 text-[#0b742f] tracking-wide drop-shadow-sm border-b-2 border-emerald-200 pb-4">
                  Referencias <span className="font-normal text-gray-500 text-lg">(Centrado)</span>
                </h2>

                <p className="mb-4 leading-7">Se debe utilizar las normas APA. Ordenadas alfabéticamente.</p>

                <p className="mb-4 text-justify leading-7">
                  En cuanto a las referencias, los autores son responsables de la exactitud e integridad de las mismas. El estilo será acorde a las normas de APA septima edición. No existe la numeración de las referencias bibliográficas, el acomodo debe ser en estricto orden alfabético. No hay separaciones por tipo de fuente consultada. <strong>El mínimo de referencias es de 15 fuentes.</strong> Las citas que se mencionen a lo largo del cuerpo del trabajo deberán ser las mismas que aparezcan en el listado de referencias.
                </p>

                <p className="mb-6 text-justify leading-7">
                  Cualquier fuente inédita y comunicaciones personales no deben incluirse como referencias, sino que deben anotarse en el texto del manuscrito entre paréntesis, al final de la oración que apoyan. Ejemplos:
                </p>

                <blockquote className="border-l-4 border-emerald-500 pl-6 py-2 mb-4 text-gray-800 leading-7 text-justify">
                  En 1989, el mundo tenía un total de 6 muros que separaban poblaciones, mientras que en 2020 esta cifra había aumentado al menos a 63 en todo el planeta. Este sorprendente incremento en las barreras físicas que dividen a las personas se plantea en el estudio <em>Un mundo amurallado. Hacia el apartheid global</em> realizado por el Centre Delàs d'Estudis per la Pau en Barcelona, España. En este se afirma que "30 años después de la caída del Muro de Berlín nos encontramos en un mundo con más muros que nunca" <span className="text-[#0b742f]">(Centre, 2020, p. 5)</span>.
                </blockquote>

                <blockquote className="border-l-4 border-emerald-500 pl-6 py-2 mb-6 text-gray-800 leading-7 text-justify">
                  Este fenómeno contrasta con la idea de <span className="text-[#0b742f]">Kenichi Ohmae (1997)</span>, quien proclamó que la globalización traería consigo un mundo sin fronteras, lo que marcaría el supuesto fin de los Estados-nación. Sin embargo, este optimismo globalizador está desmoronándose, y es aquí donde entra en juego la reflexión de <span className="text-[#0b742f]">Ricardo Forster (2006)</span>, quien considera que la frontera es el contrapunto de la globalización, es decir, el punto donde se evidencia la distancia entre promesas de integración y la realidad.
                </blockquote>

                <p className="mb-6 text-justify leading-7">
                  La lista completa de referencias debe aparecer al final del artículo en Calibri 11, interlineado simple, sin línea en blanco entre autores y con sangría francesa. Cuando sea posible, incluya el DOI de cada artículo e indique la URL si cita un trabajo en acceso abierto. Se recomienda acortar la URL en el caso de que ésta ocupe más de una línea. Ejemplos:
                </p>

                <p className="mb-4 font-normal">Normativa APA 7ª Edición:</p>

                <div className="space-y-4 mb-6">
                  <div>
                    <p className="font-bold text-gray-800 mb-1">Libro de un solo autor</p>
                    <p className="leading-7">Autor, A. (Año de publicación). <em>Título del Libro en cursiva</em>. Editorial</p>
                  </div>
                  <div>
                    <p className="font-bold text-gray-800 mb-1">Libro de varios autores</p>
                    <p className="leading-7">Autor, A., Autor, B., Autor, C.,… &amp; Autor, D. (Año de publicación). <em>Título del Libro en cursiva</em>. Editorial</p>
                  </div>
                  <div>
                    <p className="font-bold text-gray-800 mb-1">Capítulo de libro</p>
                    <p className="leading-7">Autor, A., &amp; Autor, B. (Año de publicación). Título del capítulo del libro. En/In A. Editor &amp; B. Editor (Eds.), <em>Título del libro en cursiva</em> (pp. xxx-xxx). Editorial. https://doi.org/xxxxxxxx</p>
                  </div>
                  <div>
                    <p className="font-bold text-gray-800 mb-1">Artículo de revista</p>
                    <p className="leading-7">Autor, A., Autor, B., &amp; Autor, C. (Año de la publicación). Título del artículo. <em>Nombre de la Revista en cursiva, volumen</em>(número), pp-pp. https://doi.org/xxxxxxxx</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Contribución de autores */}
          <section id="contribucion-autores" className="scroll-mt-32">
            <div className="bg-gradient-to-br from-white via-blue-50/30 to-white rounded-2xl shadow-2xl p-8 border-l-8 border-[#0b742f] hover:shadow-3xl transition-shadow">
              <div className="prose prose-slate max-w-none text-base leading-relaxed text-gray-800">
                <h2 className="text-center font-bold text-2xl mb-8 text-[#0b742f] tracking-wide drop-shadow-sm border-b-2 border-blue-200 pb-4">
                  Contribución de autores
                </h2>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm border-collapse border border-gray-400 bg-white">
                    <thead>
                      <tr className="bg-blue-50">
                        <th className="border border-gray-400 px-3 py-2 font-bold text-gray-800 text-left">Rol CRediT</th>
                        <th className="border border-gray-400 px-3 py-2 font-bold text-gray-800 text-center">Nombre Autor</th>
                        <th className="border border-gray-400 px-3 py-2 font-bold text-gray-800 text-center">Nombre Autor</th>
                        <th className="border border-gray-400 px-3 py-2 font-bold text-gray-800 text-center">Nombre Autor</th>
                        <th className="border border-gray-400 px-3 py-2 font-bold text-gray-800 text-center">Nombre Autor</th>
                        <th className="border border-gray-400 px-3 py-2 font-bold text-gray-800 text-center">Nombre Autor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Conceptualización", "✓/✓", "", "", "", ""],
                        ["Metodología", "", "✓/✓", "", "", ""],
                        ["Software", "", "", "✓/✓", "", ""],
                        ["Validación", "", "", "", "✓/✓", ""],
                        ["Análisis formal", "", "", "", "", "✓/✓"],
                        ["Investigación", "✓/✓", "", "", "", ""],
                        ["Recursos", "", "✓/✓", "", "", ""],
                        ["Curación de datos", "", "", "✓/✓", "", ""],
                        ["Redacción – borrador original", "", "", "", "✓/✓", ""],
                        ["Redacción – revisión y edición", "", "", "", "", "✓/✓"],
                        ["Visualización", "✓/✓", "", "", "", ""],
                        ["Supervisión", "", "✓/✓", "", "", ""],
                        ["Administración del proyecto", "", "", "✓/✓", "", ""],
                        ["Obtención de financiamiento", "", "", "", "✓/✓", ""],
                      ].map(([rol, ...cols], i) => (
                        <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                          <td className="border border-gray-400 px-3 py-2 text-gray-800">{rol}</td>
                          {cols.map((c, j) => (
                            <td key={j} className="border border-gray-400 px-3 py-2 text-center text-gray-700">{c}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>

        </div>
      </main>
    </div>
  </div>
  );
};

export default EjemploCapitulo;
